var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnoozeSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3496 66L19.409 62.98L16.7545 40.411L20.0592 40.7278L9.02397 50.935L5 46.8024L19.3512 33.5279L22.266 36.5215L25.0279 59.0415L21.8236 58.934L33.8372 47.8216L37.7064 51.7954L22.3496 66Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.636 61.9008L43.7541 56.3228L49.9654 22.7898L54.5709 24.639L34.1889 34.6425L30.2453 27.0095L56.7518 14L59.6085 19.529L53.573 53.0371L49.0188 51.5307L71.208 40.6402L75 47.9796L46.636 61.9008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnoozeSleep);
export default __webpack_public_path__ + "static/media/snooze-sleep.c6a5cb400280dc47697b743c398edda8.svg";
export { ForwardRef as ReactComponent };